import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons';

const ButtonMute = ({ onClick }) => {
    const [isMuted, setIsMuted] = useState(false);

    useEffect(() => {
        const audio = document.getElementById('background-audio');
        if (audio) {
            audio.muted = isMuted;
        }
    }, [isMuted]);

    useEffect(() => {
        const audio = document.getElementById('background-audio');
        if (audio) {
            audio.volume = 0.2; 
        }
    }, []);

    const handleClick = () => {
        setIsMuted(prev => !prev);
        onClick();
    };

    return (
        <button className="mute-button lg:w-14 lg:h-14 sm:w-10 sm:h-10" onClick={handleClick}>
            <FontAwesomeIcon icon={isMuted ? faVolumeMute : faVolumeUp} className='sm:text-xl font-bold lg:text-2xl'/>
        </button>
    );
};

export default ButtonMute;
